module.exports = __webpack_public_path__ + "img/KX.2dd72c4a.png";